import "can/model/";

function modifiedDataSource( data ) {
    "use strict";
    var userRoles = [];
	
	_.forEach( data, function(value){
		if( value.name == 'USER_ROLE_ELEVATEDUSER' ) return;
		
		userRoles.push(value);
	})
	
	return userRoles;
}

export default can.Model.extend({
    findAll: function() {
        "use strict";
        return can.ajax({
            url: "/api/v2/userRoles",
            type: "GET",
            dataType: "json"
        });
    },

    create: function ( params ) {
        "use strict";
        return can.ajax({
            url: "/api/v2/userRoles",
            type: "POST",
            data: JSON.stringify(params.data),
            contentType: "application/json",
            dataType: "JSON"
        });
    },

    update: function( id, params ) {
        "use strict";
        return can.ajax({
            url: "/api/v2/userRoles",
            type: "PUT",
            data: JSON.stringify(params.data),
            contentType: "application/json",
            dataType: "JSON"
        });
    },

    destroy: "/api/v2/userRoles/{id}",
	
	parseModels: function( data ) {
        "use strict";
        return modifiedDataSource( data );
    }
	
}, {});